
import { Vue, Component, Prop } from 'vue-property-decorator';
import AddressInfo from '@/features/shipment-history/components/tableColumns/AddressInfo.vue';
import { HistoryItemType } from '@/features/shipment-history/types';

@Component({
  components: {
    AddressInfo,
  },
})
export default class ShipTo extends Vue {
  @Prop({ required: true }) item!: HistoryItemType;
}
